import { Component } from '@angular/core';

@Component({
  templateUrl: 'editagent2.component.html'
})
export class Editagent2Component {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/agencies/editagent2.component.ts